module.exports = __webpack_public_path__ + "img/m_y.e523ee7a.png";